import BaseModel from './BaseModel';
import { TRANSLATE_LANGUAGE } from '../constants/Define';
export default class EmailTemplate extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.title = data.title || this.translate.title || undefined;
        this.content = data.content || this.translate.content || undefined;
        this.note = data.note || this.translate.note || undefined;
        this.isActive = data.isActive !== undefined ? data.isActive : true;
        this.languageCode = TRANSLATE_LANGUAGE.VN;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            title: this.title,
            content: this.content,
            note: this.note,
            isActive: this.isActive,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                emailId: this.translate.emailId || this.id,
                title: this.title,
                content: this.content,
                note: this.note,
            }
        }
        return result;
    }

}
